import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AuthSuccess from "./components/Auth/AuthSuccess";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/SignUp";
import AuthRoute from "./components/Auth/AuthRoute";
import RedirectIfAuthenticated from "./components/Auth/RedirectIfAuthenticated";
import ClientDetails from "./components/Clients/ClientDetails";
import InteractionDetails from "./components/Interactions/InteractionDetails";
import ResetPassword from "./components/Auth/ResetPassword"; // Import the ResetPassword component
import { ThemeProvider } from "@mui/material";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<RedirectIfAuthenticated element={<Login />} />}
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/success" element={<AuthSuccess />} />
          <Route path="/" element={<AuthRoute element={<Home />} />} />
          <Route
            path="/clients/:clientId"
            element={<AuthRoute element={<ClientDetails />} />}
          />
          <Route
            path="/interactions/:interactionId"
            element={<AuthRoute element={<InteractionDetails />} />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />{" "}
          {/* Add the ResetPassword route */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
